import { FunctionComponent, ReactNode } from "react";
import labelContentVertical from "./SteppersLabelContentVertical.module.css";
import labelContentHorizontal from "./SteppersLabelContentHorizontal.module.css";

export type SteppersLabelContentType = {
  className?: string;
  label?: string;
  description?: ReactNode;
  size?: "sm" | "md" | "lg";
  type?: "incomplete" | "inprogress" | "complete";
  direction?: "vertical" | "horizontal";
};

const labelContentStyles = {
  vertical: labelContentVertical,
  horizontal: labelContentHorizontal,
} as const;

const SteppersLabelContentAtom: FunctionComponent<SteppersLabelContentType> = ({
  className = "",
  size = "sm",
  type = "incomplete",
  label = "Label",
  description,
  direction = "vertical",
}) => {
  const styles = labelContentStyles[direction];
  return (
    <div
      className={[styles.root, className, "quill-ui-next-atom"].join(" ")}
      data-size={size}
      data-type={type}
    >
      <b className={styles.label}>{label}</b>
      {description && <div className={styles.description}>{description}</div>}
    </div>
  );
};

export default SteppersLabelContentAtom;
